import { render } from "./ProcedureAccessibility.vue?vue&type=template&id=170d8c56&scoped=true"
import script from "./ProcedureAccessibility.vue?vue&type=script&lang=js"
export * from "./ProcedureAccessibility.vue?vue&type=script&lang=js"

import "./ProcedureAccessibility.vue?vue&type=style&index=0&id=170d8c56&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170d8c56"]])

export default __exports__